import { validateEmail, validateNorwegianPhoneNumber } from '@gjensidige/service-input-validator';

/** Returns an error message string, or undefined if valid. */
export type Validator = (value: string) => string | undefined;

export const validators = {
  required:
    (label: string): Validator =>
    (value) =>
      !value.trim() ? `${label} er påkrevd` : undefined,

  postalCode: (): Validator => (value) => {
    if (!value.trim()) return 'Postnummer er påkrevd';
    if (!/^\d{4}$/.test(value)) return 'Postnummer må være 4 siffer';
    return undefined;
  },

  postPlace: (): Validator => (value) => {
    if (!value.trim()) return 'Poststed er påkrevd';
    if (/\d/.test(value)) return 'Poststed kan ikke inneholde tall';
    return undefined;
  },

  email: (): Validator => (value) => {
    if (!value.trim()) return 'E-post er påkrevd';
    if (!validateEmail(value)) return 'Ugyldig e-postadresse';
    return undefined;
  },

  /** Phone is optional — only validates format if a value is entered. */
  phone: (): Validator => (value) => {
    if (!value.trim()) return undefined;
    if (!validateNorwegianPhoneNumber(value)) return 'Ugyldig telefonnummer';
    return undefined;
  },

  birthdate: (): Validator => (value) => {
    if (!value.trim()) return 'Fødselsdato er påkrevd';
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Ugyldig fødselsdato';
    if (date > new Date()) return 'Fødselsdato kan ikke være i fremtiden';
    if (date < new Date('1900-01-01')) return 'Ugyldig fødselsdato';
    return undefined;
  },
};
